/**
 * Phone layout switch. Phones get their own layout (bottom navigation, bottom sheets, larger touch
 * targets); tablets and desktops keep the regular layout. Landscape phones count as phones.
 */
import { useSyncExternalStore } from 'react';

export const PHONE_QUERY = '(max-width: 600px), (max-height: 500px) and (pointer: coarse)';

const query = (): MediaQueryList | null => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(PHONE_QUERY) : null);

function subscribe(onChange: () => void): () => void {
  const mq = query();
  mq?.addEventListener('change', onChange);
  return () => mq?.removeEventListener('change', onChange);
}

export function usePhone(): boolean {
  return useSyncExternalStore(subscribe, () => query()?.matches ?? false, () => false);
}
